import Component from "../abstracts/Component";

export default class CarouselComponent extends Component {
  get SELECTORS() {
    return {
      main: '[data-carousel="true"]:not(.slick-initialized)',
      prevArrow: '[data-prev-arrow]',
      nextArrow: '[data-next-arrow]',
    };
  }

  constructor() {
    super();
    this.main = $(this.SELECTORS.main);
    this.whatchRes = [];
  }

  importLibrary(elem, editorial = false) {
    this.moduleLoader.loadCarouselAndExecute(
      module => {
        // to load async carousels like recommendation
        if (editorial) {
          this.initEditorialCarousel(elem);
        } else {
          this.initCarousels(elem);
        }
        this.manageMobileCarousels();
      },
      error => {
        console.error("failed to load slick ", error.stack);
      }
    );
  }

  initCarousels(elem) {
    let selector = this.SELECTORS.main;
    let carousels = [];
    if (
      elem != null &&
      typeof elem != "undefined" &&
      document.getElementsByClassName(elem).length
    )
      carousels = document.getElementsByClassName(elem);
    else carousels = document.querySelectorAll(selector);

    for (let carousel of carousels) {
      /* TODO: refactoring: call slick in each specific js component, instead of this.
               Also, initEditorialCarousel should be in a separate file */
      if (carousel.dataset.isEditorialCarousel === "true") {
        this.initEditorialCarousel(carousel);
      } else {
        const slides =
          typeof carousel.dataset.slides != "undefined"
            ? Number(carousel.dataset.slides)
            : 1;
        const visibleItemsMobile =
          this.checkMobileCarousel(carousel);
        const visibleItemsTablet =
          typeof carousel.dataset.visibleItemsMd != "undefined"
            ? Number(carousel.dataset.visibleItemsMd)
            : slides;
        const visibleItemsDesktop =
          typeof carousel.dataset.visibleItemsLg != "undefined"
            ? Number(carousel.dataset.visibleItemsLg)
            : slides;
        const isDots = carousel.dataset.dots === "true" ? true : false;
        const isFade = carousel.dataset.fade === "true" ? true : false;
        const isCenter = carousel.dataset.centerslick === "true" ? true : false;
        const isArrows = carousel.dataset.arrows === "true" ? true : false;
        const prevArrow =
          carousel.dataset.customarrows === "true"
            ? '<span class="fade-prev__outer"></span><button class="slick-prev slick-arrow" aria-label="Previous" type="button" style="">Previous</button><span class="fade-prev_inner"></span>'
            : '<span class="fade-prev__outer"></span><button type="button" class="w__slick-prev icon-slick-prev" aria-label="previous slide" data-prev-arrow><i class="icon-slick-prev"></i></button><span class="fade-prev__inner"></span>';
        const nextArrow =
          carousel.dataset.customarrows === "true"
            ? '<span class="fade-next__inner"></span><button class="slick-next slick-arrow" aria-label="Next" type="button" style="">Next</button><span class="fade-next__outer"></span>'
            : '<span class="fade-next__inner"></span><button type="button" class="w__slick-next icon-slick-next" aria-label="next slide" data-next-arrow><i class="icon-slick-next"></i></button><span class="fade-next__outer"></span>';
        const isAccessible =
          carousel.dataset.accessibility === "true" ? true : false;
        const isAutoplay = carousel.dataset.autoplay === "true" ? true : false;
        const isDraggable = carousel.dataset.draggable === "false" ? false : true;
        const isInfinite = carousel.dataset.infinite === "true" ? true : false;
        const autoplaySpeed =
          typeof carousel.dataset.autoplaySpeed != "undefined"
            ? carousel.dataset.autoplaySpeed
            : 3000;
        const slidesToScroll =
          typeof carousel.dataset.slidesToScroll != "undefined"
            ? Number(carousel.dataset.slidesToScroll)
            : 1;
        const slidesToScrollMobile =
          typeof carousel.dataset.slidesToScrollMobile != "undefined"
            ? Number(carousel.dataset.slidesToScrollMobile)
            : 1;
        const isVariableWidth =
          carousel.dataset.variablewidth === "true" ? true : false;
        const centerPadding =
          carousel.dataset.centerpadding != undefined ? carousel.dataset.centerpadding : "";
        const customPaging = function (slider, i) {
          return $('<i class="icon-slider-bullet"></i><i class="icon-slider-bullet-active"></i>');
        };

        let options = {
          dots: isDots,
          arrows: isArrows,
          prevArrow: prevArrow,
          nextArrow: nextArrow,
          infinite: isInfinite,
          centerMode: isCenter,
          centerPadding: centerPadding,
          autoplay: isAutoplay,
          autoplaySpeed: autoplaySpeed,
          accessibility: isAccessible,
          draggable: isDraggable,
          slidesToShow: slides,
          slidesToScroll: slidesToScroll,
          slidesToScrollMobile: slidesToScrollMobile,
          fade: isFade,
          variableWidth: isVariableWidth,
          customPaging: customPaging
        };

        let responsiveArray = this.setResponsiveArray(
          visibleItemsMobile,
          visibleItemsTablet,
          visibleItemsDesktop,
          slidesToScrollMobile
        );

        options = $.extend({}, options, {
          responsive: responsiveArray
        });

        const editMode = carousel.dataset.editMode === "true" ? true : false;
        if (editMode) return false;

        const onlyMobile = carousel.dataset.onlyMobile === "true" ? true : false;

        let checkItems = slides;
        if (window.matchMedia("(max-width:767px)").matches || onlyMobile)
          checkItems = visibleItemsMobile;
        else if (window.matchMedia("(max-width:1280px)").matches)
          checkItems = visibleItemsTablet;
        $(carousel).on('init', () => {
          this.animateArrows(carousel);
          this.$emit(this.$customEvents.CAROUSEL.initCarousel, {carousel: carousel});
        });
        if (
          carousel.children.length < checkItems ||
          !$(carousel).is(":visible")
        ) {
          this.log("Carousel not triggered");
        } else if (window.matchMedia("(max-width:767px)").matches && onlyMobile) {
          $(carousel).slick(options);
          this.log("Carousel Triggered");
        } else if (!onlyMobile) {
          $(carousel).slick(options);
          this.log("Carousel Triggered");
        }
        //for keyboard navigation: removed possibility to navigate in an hidden slide
        $(carousel).on('afterChange', (event, slick, currentSlide) => {
          this.setTabIndexForVisibleSlides(carousel);
        });
      }
    }
  }

  initEditorialCarousel(carousel) {
    $(carousel).slick({
      slidesToShow: 2,
      slidesToScroll: 2,
      arrows: true,
      infinite: false,
      autoplay: false,
      prevArrow: '<div class="w-c-l__arrow" data-prev-arrow="true"><button aria-labelledby="carousel-prev-label"><i class="icon-chevron-left"></i></button></div>',
      nextArrow: '<div class="w-c-l__arrow" data-next-arrow="true"><button aria-labelledby="carousel-next-label"><i class="icon-chevron-right"></i></button></div>',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            arrows: false
          },
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          },
        },
        {
          breakpoint: 1440,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4
          },
        },
        {
          breakpoint: 90000,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 5
          }
        }
      ]
    });
  }

  setResponsiveArray(
    visibleItemsMobile,
    visibleItemsTablet,
    visibleItemsDesktop,
    slidesToScrollMobile
  ) {
    let responsiveArray = [];
    if (visibleItemsMobile == "unslick") {
      responsiveArray.push({
        breakpoint: 768,
        settings: visibleItemsMobile
      });
    } else {
      responsiveArray.push({
        breakpoint: 768,
        settings: {
          slidesToShow: visibleItemsMobile,
          slidesToScroll: slidesToScrollMobile
        }
      });
    }
    if (visibleItemsTablet == "unslick") {
      responsiveArray.push({
        breakpoint: 1280,
        settings: visibleItemsTablet
      });
    } else {
      responsiveArray.push({
        breakpoint: 1280,
        settings: {
          slidesToShow: visibleItemsTablet
        }
      });
    }
    //set only if not a carousel in desktop else use default configs
    if (visibleItemsDesktop == "unslick") {
      responsiveArray.push({
        breakpoint: 60000,
        settings: visibleItemsDesktop
      });
    }
    return responsiveArray;
  }

  animateArrows(carousel) {
    let prevArrow = carousel.querySelector(this.SELECTORS.prevArrow);
    if (prevArrow) {
      prevArrow.addEventListener('mousedown', () => {
        prevArrow.classList.remove('transition');
      });
      prevArrow.addEventListener('click', () => {
        prevArrow.classList.add('transition');
      });
    }
    let nextArrow = carousel.querySelector(this.SELECTORS.nextArrow);
    if (nextArrow) {
      nextArrow.addEventListener('mousedown', () => {
        nextArrow.classList.remove('transition');
      });
      nextArrow.addEventListener('click', () => {
        nextArrow.classList.add('transition');
      });
    }
  }

  checkMobileCarousel(carousel) {
    if (carousel.classList.contains('not-mobile')) {
      return 'unslick';
    } else {
      if (typeof carousel.dataset.visibleItemsXs !== "undefined") {
        return Number(carousel.dataset.visibleItemsXs);
      } else { return carousel.dataset.slides;}
    }
  }

  bindEvents() {
    this.$on(this.$customEvents.MODAL_EVENTS.afterOpen, () => {
      console.log("afterOpen Modal");
      let carouselsIntoVex = document
        .querySelector(".vex")
        .querySelectorAll('[data-carousel="in-vex"]');
      if (carouselsIntoVex.length > 0) {
        for (let carouselInVex of carouselsIntoVex) {
          carouselInVex.dataset.carousel = "true";
        }
        this.initCarousels();
      }
    });

    this.$on(this.$customEvents.CAROUSEL.triggerCarousel, data => {
      this.importLibrary(data.payload);
    });
  
    //for keyboard navigation: removed possibility to navigate in an hidden slide at the init stage
    $(document).on('init', '.slick-slider', (event, slick) => {
      this.setTabIndexForVisibleSlides(event.target);
    });
  }

  setTabIndexForVisibleSlides(carousel) {
    $(carousel).find('.slick-slide a').each(function() {
      const parentSlide = $(this).closest('.slick-slide');
      if (!parentSlide.hasClass('slick-current')) {
        $(this).attr('tabindex', '-1'); // focus disable
      } else {
        $(this).attr('tabindex', '0'); // focus enable
      }
    });
  }
  

  manageMobileCarousels() {
    let carousels = document.querySelectorAll('.slick-slider');
    for (let carousel of carousels) {
      let slickDots = $(carousel).find('.slick-dots');
      if (slickDots.length) {
        if ($(slickDots).children('li').length > 6 && $(slickDots).parent('.slick-dots-container').length == 0) {
          $(slickDots).wrap("<div class='slick-dots-container'></div>");
          $(slickDots).find('li').each(function (index) {
            $(this).addClass('dot-index-' + index);
          });
          if (slickDots.children('li').length > 14) {
            $(slickDots).css('transform', 'translateX(80px)');
          } else {
            $(slickDots).css('transform', 'translateX(40px)');
          }
          $(carousel).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            let currentTranslateX = parseInt($(this).find('.slick-dots').css('transform').split(',')[4]);
            let transformCount = 0;
            if (!$(this).find('ul.slick-dots li:first-child').hasClass('slick-active') &&
              !$(this).find('ul.slick-dots li:nth-child(2)').hasClass('slick-active') &&
              !$(this).find('ul.slick-dots li:last-child').hasClass('slick-active') &&
              !$(this).find('ul.slick-dots li:nth-last-child(2)').hasClass('slick-active')) {
              if (nextSlide > currentSlide) {
                if(!$(this).find('ul.slick-dots li:nth-last-child(3)').hasClass('slick-active')) {
                  transformCount = currentTranslateX - 40;
                  $(this).find('ul.slick-dots').css('transform', 'translateX(' + transformCount + 'px)');
                }
              } else {
                if(!$(this).find('ul.slick-dots li:nth-child(3)').hasClass('slick-active') ) {
                  transformCount = currentTranslateX + 40;
                  $(this).find('ul.slick-dots').css('transform', 'translateX(' + transformCount + 'px)');
                }
              }
            }
          });
        }
      }
    }
  }

  render() {
    super.render();
    if (document.querySelectorAll("[data-carousel]").length) {
      this.importLibrary();
    }
    this.bindEvents();
  }
}
